<template>
    <div>
        <div class="d-flex justify-content-between">
            <div class=" mb-3">
                <h3 class="">{{ agency }}</h3>
            </div>
            <div class="float-right mb-2" v-if="this.certificates.length > 0">Authentic Certificates ({{ this.certificates.length }})</div>
        </div>
        <div>
            <webix-ui :config="ui" v-model="certificates"></webix-ui>
            <!-- <div id="vettingTablePaging"></div> -->
        </div>
        <!-- {{ certificate_ids }} -->
    </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
    props: {
        certificates: {},
        remaining_quota: {},
        agency: {},
    },
    data: () => ({
        certificate_ids: [],
    }),
    computed: {
        pagerName() {
            return this.agency + "Pager";
        },
        ui() {
            let el = this;

            let newAgency = el.agency + "table";

            let ui = {
                id: newAgency,
                view: "datatable",
                css: "datatableUsers webix_header_border webix_data_border datatableHover",
                autoheight: true,
                // hover: "datatableHover",
                // select: "cell",
                // hover: "suppliersTableHoverRow",
                minHeight: 50,
                minColumnWidth: 120,
                rowHeight: 30,
                scrollY: false,
                scrollX: true,
                resizeColumn: true,
                // select: false,
                editable: true,
                // pager: {
                //     id: el.pagerName,
                //     template: "{common.prev()} {common.pages()} {common.next()}",
                //     container: "vettingTablePaging",
                //     css: { width: "100% !important" },
                //     size: 15,
                //     group: 5,
                // },
                columns: [
                    {
                        id: "client_name",
                        header: { text: "Client Name", css: { "text-align": "center" } },
                        tooltip: false,
                        width: 300,
                    },
                    {
                        id: "company_name",
                        header: { text: "Company", css: { "text-align": "center" } },
                        // css: { "text-align": "center" },
                        tooltip: false,
                        // width: 50,
                        width: 300,
                    },
                    {
                        id: "vat_no",
                        header: { text: "Vat No", css: { "text-align": "center" } },
                        tooltip: false,
                        width: 150,
                    },
                    {
                        id: "company_reg",
                        header: { text: "Company Reg No", css: { "text-align": "center" } },
                        tooltip: false,
                        width: 150,
                    },

                    {
                        id: "authentication_status",
                        header: { text: "Status", css: { "text-align": "center" } },
                        css: { "text-align": "center" },
                        tooltip: false,
                        width: 200,
                        sort: "string",
                    },
                    {
                        id: "authentication_request_date",
                        header: { text: "Auth Request Date", css: { "text-align": "center" } },
                        css: { "text-align": "center" },
                        tooltip: false,
                        width: 200,
                        sort: "string",
                    },
                ],
                ready() {
                    // el.resize_event = window.webix.event(window, "resize", function() {
                    //     el.$nextTick(() => {
                    //         window.webix.$$(el.ui.id).refresh();
                    //     });
                    // });
                },
                on: {
                    //eslint-disable-next-line
                    onEditorChange: function(id, value) {
                        //eslint-disable-next-line
                        console.log("oneditorChange", id, value);
                    },
                    //eslint-disable-next-line
                    onBeforeEditStart: function(row, column) {
                        //eslint-disable-next-line
                        console.log(row);
                        const el = this.$scope.$parent;
                        el.test = row;
                        //eslint-disable-next-line
                        console.log("el test", el.test);
                    },
                    //eslint-disable-next-line
                    onBeforeEditStop: function(state, editor, ignore) {
                        const el = this.$scope.$parent;
                        var check = editor.getValue();
                        //eslint-disable-next-line
                        console.log("CHECK", check, el.test);
                    },
                    //eslint-disable-next-line
                    // onChange: function(newValue, oldValue, config) {
                    //     // config is {yourProperty: "yourValue"}
                    //     //eslint-disable-next-line
                    //     console.log("over here");
                    // },
                    //eslint-disable-next-line
                    onAfterEditStop(state, editor) {
                        //eslint-disable-next-line
                        const el = this.$scope.$parent;
                        const clickedRow = editor.row;
                        const actualRow = this.getItem(clickedRow);

                        let newState = state.value; // ""
                        let oldState = state.old; // undefined

                        oldState == undefined ? (oldState = "") : null; // basically type casting

                        // if (newState == oldState) {
                        //     //eslint-disable-next-line
                        //     console.log("nothing changed");
                        // }
                        if (newState !== oldState) {
                            if (newState.length > 1) {
                                //handle the comma delineation of webix state
                                newState = newState.split(",");
                            } else if (newState == 1) {
                                // if only one value is present in the state
                                newState = [newState];
                            } else {
                                //if state is empty
                                newState = [];
                            }

                            // TODO: .then refresh the collection list again
                            el.assignTeamMembersToClient({
                                collection_id: actualRow.collection_id,
                                validators: newState,
                            });
                        }

                        //eslint-disable-next-line
                        console.log("onAfterEditStop", actualRow);
                    },
                },
                onChange: {},
                onClick: {},
            };
            //pager
            // if (this.certificates.length >= 2) {
            //     ui.pager = {
            //         template: "{common.prev()} {common.pages()} {common.next()}",
            //         container: "certificateListModalPaging",
            //         css: { width: "100% !important" },
            //         size: 2,
            //         group: 5,
            //     };
            // }
            return ui;
        },
    },
    methods: {
        handleSwal() {
            Swal.fire({
                title: `Maximum allocation reached`,
                text: `Only 10 certificates may be sent for authentication per day`,
                icon: "warning",
                // showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Ok",
            }).then((result) => {
                if (result.value) {
                    //eslint-disable-next-line
                }
            });
        },

        sendCertificates() {
            Swal.fire({
                title: `Send for Authentication?`,
                text: `Are you sure`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Confirm",
            }).then((result) => {
                if (result.value) {
                    //eslint-disable-next-line
                }
            });
        },
    },
    mounted() {
        this.vettingCount = this.remaining_quota;
    },
};
</script>

<style lang="scss">
.active_switch {
    // color: darken(#28a745, 10%);
    cursor: pointer;
    font-weight: 100;
}
.non-active_switch {
    cursor: pointer;
}
</style>
